var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useCallback, Fragment } from 'react';
import { TextSkeleton } from './TextSkeleton';
import { FormGroup } from './FormGroup';
import { TextField } from './TextField';
import { Skeleton } from '../module';
export var Form = function (_a) {
    var onSubmit = _a.onSubmit, children = _a.children, busy = _a.busy, props = __rest(_a, ["onSubmit", "children", "busy"]);
    var _onSubmit = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        onSubmit(e);
    }, [onSubmit]);
    return (jsx("form", __assign({ onSubmit: _onSubmit, noValidate: true, autoComplete: "off" }, props), busy ? (jsx(Fragment, null,
        jsx(FormGroup, { label: jsx(TextSkeleton, null) },
            jsx(TextField, { as: Skeleton }, "\u00A0")),
        jsx(FormGroup, { label: jsx(TextSkeleton, null) },
            jsx(TextField, { as: Skeleton }, "\u00A0")),
        jsx(FormGroup, { label: jsx(TextSkeleton, null) },
            jsx(TextField, { as: Skeleton }, "\u00A0")))) : (children)));
};
//# sourceMappingURL=Form.js.map